import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { GenericTableHeaderComponent, GenericTableHeaderOptions } from '@huge-monorepo/shared/components';
import { SharedGenericSingletonService, SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import {
  ICustomerGenericService,
  ICustomerTeltonikaService, IHIPGenericService,
  IHIPTeltonikaService,
  TableHeader,
  Tag,
  TeltonikaSelectAllData,
} from '@huge-monorepo/shared/interfaces';
import { GenericService } from '@huge-monorepo/hip/services';
@Component({
  selector: 'huge-monorepo-teltonika-connected-devices-report',
  standalone: true,
  imports: [CommonModule, MaterialModule, ToolsModule, GenericTableHeaderComponent],
  templateUrl: './teltonika-connected-devices-report.component.html',
  styleUrl: './teltonika-connected-devices-report.component.scss',
})
export class TeltonikaConnectedDevicesReportComponent {
  teltonikaService = this.sharedTeltonikaService.getService();
  isHIP = this.sharedTeltonikaService.getIsHIP();
  viewDevices: boolean = true;
  selectedDevices: object[] = [];
  selectedTags: Tag[] = [];
  loading: boolean = false;
  allDevicesSelected: boolean = false;
  deviceSearch: string = '';

  appliedFilters: { Firmware: string | null, Model: string | null, DeviceStatus: string | null } = { Firmware: null, Model: null, DeviceStatus: null };


  tagTableHeaders: TableHeader[] = [
    {
      ID: 'Name',
      Index: 0,
      Sort: 'Name',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },

    {
      ID: 'Description',
      Index: 1,
      Sort: 'Description',
      Sortable: false,
      Text: 'Description',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'DeviceCount',
      Index: 2,
      Sort: 'DeviceCount',
      Sortable: false,
      Text: 'Devices',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'CreatedAt',
      Index: 3,
      Sort: 'CreatedAt',
      Sortable: false,
      Text: 'Created At',
      Type: Date,
      Align: 'left',
    },

  ];

  deviceTableHeaders: TableHeader[] = [
    {
      ID: 'TeltonikaCustomName',
      Index: 0,
      Sort: 'TeltonikaCustomName',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'name',
      Index: 1,
      Sort: 'name',
      Sortable: false,
      Text: 'Serial',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'MACAddress',
      Index: 2,
      Sort: 'MACAddress',
      Sortable: false,
      Text: 'MAC',
      Type: String,
      Align: 'left',
    },
    ...(this.isHIP ? [{
      ID: 'TeltonikaSortTag',
      Index: 3,
      Sort: 'TeltonikaTag',
      Sortable: false,
      Text: 'Tag',
      Type: Object,
      Align: 'left',
      ObjectKey: 'Name'
    }] : []),
  ];

  constructor(
    private tools: SharedToolsService,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private genericSingleton: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
  ) {
  }

  headerConfig: GenericTableHeaderOptions = {
    DateRequired: true,
    EnableExport: false,
    DateItem: {
      Singular: false,
      Title: "Report Generation Period",
      Type: 'day'
    },
  };

  addSelectedDevice(e: object[]) {
    this.selectedDevices = e;
  }

  allDevicesSelectedEvent(e: boolean) {
    this.allDevicesSelected = e;
  }

  searchDevices(e: string) {
    this.deviceSearch = e;
  }


  addSelectedTag(e: Tag[]) {
    this.selectedTags = e;
  }

  reset() {
    this.selectedDevices = [];
    this.selectedTags = [];
    this.deviceSearch = '';
  }

  generateReport() {
    this.loading = true;
    let ids: number[] = [];
    if (this.isHIP) {
      if (this.viewDevices) {
        this.selectedDevices.forEach((device) => {
          ids.push(device['id']);
        });
      }

      this.teltonikaService.generateTeltonikaConnectedDevicesReport(ids, this.allDevicesSelected, this.buildSelectAllData()).subscribe({
        complete: () => {
          this.loading = false;
          this.selectedDevices = [];
          this.selectedTags = [];
          this.allDevicesSelected = false;
          this.deviceSearch = '';
        }
      });
    } else {
      this.teltonikaService.generateTeltonikaConnectedDevicesReport().subscribe({
        complete: () => {
          this.loading = false;
          this.selectedDevices = [];
          this.selectedTags = [];
          this.allDevicesSelected = false;
          this.deviceSearch = '';
        }
      });
    }
  }


  buildSelectAllData(): TeltonikaSelectAllData | null {
    if (!this.viewDevices) {
      let tagID: number | undefined = undefined;
      this.selectedTags.forEach((tag) => {
        tagID = tag.ID;
      });
      return {
        TagID: tagID,
      };
    } else if (this.allDevicesSelected) {
      return {
        Search: this.deviceSearch,
      };
    }
    return null;
  }
}
